import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { useEffect, useMemo, useState } from 'react';
import { LOAD_MORE_OPTION_VALUE, PROPERTY_REFERENCE_TYPES } from '../constants/associations';
import { propertyFieldTypes, propertyKeyValidationTypes } from '../constants/properties';
import useSelectValues from './useSelectValues';
import { jsx as _jsx } from "react/jsx-runtime";
const useSelectOptions = ({
  property,
  objectType,
  currentValue,
  loadOptions,
  hubspotUserId,
  setExternalValue
}) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const {
    fetchedExternadOptions,
    referenceType
  } = useSelectValues({
    property,
    objectType
  });
  const modifiedOptions = useMemo(() => {
    var _fetchedExternadOptio;
    let options = (fetchedExternadOptions === null || fetchedExternadOptions === void 0 || (_fetchedExternadOptio = fetchedExternadOptions.results) === null || _fetchedExternadOptio === void 0 ? void 0 : _fetchedExternadOptio.map(el => Object.assign({}, el, {
      text: el.label,
      value: el.id
    }))) || [];

    // for some reason api doesn`t allow us to change lifecyclestage upper
    // only down to the list, so if we at some point need to cut options
    // which we can`t choose from
    if (property.name === propertyKeyValidationTypes.lifecyclestage && currentValue) {
      const currentOptionIndex = options.findIndex(el => el.value === currentValue);
      options = options.slice(currentOptionIndex);
    }
    setIsDisabled(property.externalOptions && fetchedExternadOptions !== null && fetchedExternadOptions !== void 0 && fetchedExternadOptions.results ? !options.length : false);
    return options;
  }, [fetchedExternadOptions, property, currentValue]);
  const [selectOptions, setSelectOptions] = useState(modifiedOptions || []);
  useEffect(() => {
    // set default select option for external options
    if (property.type === 'enumeration' && property.fieldType !== propertyFieldTypes.checkbox && !currentValue) {
      var _selectOptions$;
      const selectedValue = selectOptions.find(item => !item.isSpecial && item.id === currentValue);
      if (property.referenceType === 'OWNER' && !selectedValue && hubspotUserId) {
        const currentOwner = selectOptions.find(item => Number(item.additionalFields.activeUserId) === hubspotUserId);
        if (currentOwner) {
          setExternalValue(currentOwner.value || '');
          return;
        }
      }
      setExternalValue(selectedValue ? selectedValue.id : ((_selectOptions$ = selectOptions[0]) === null || _selectOptions$ === void 0 ? void 0 : _selectOptions$.value) || '');
    }
  }, [currentValue, hubspotUserId, property, selectOptions, setExternalValue]);
  useEffect(() => {
    setSelectOptions(modifiedOptions || []);
  }, [modifiedOptions]);

  // add load more option in case if we have more pages
  useEffect(() => {
    if (referenceType !== PROPERTY_REFERENCE_TYPES.PIPELINE_STAGE) {
      // add button in case if we have more pages
      if (fetchedExternadOptions && !fetchedExternadOptions.isLoading && !fetchedExternadOptions.isError && fetchedExternadOptions.hasMore && !selectOptions.find(option => option.isSpecial === true)) {
        const loadMoreOption = {
          dropdownText: /*#__PURE__*/_jsx(Link, {
            onClick: () => loadOptions(''),
            "data-test-id": "dropdown-load-more-button",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "associationsPanel.tabs.create.associationProperties.loadMore"
            })
          }),
          input: '',
          isSpecial: true,
          title: '',
          value: LOAD_MORE_OPTION_VALUE,
          archived: false,
          description: '',
          disabled: false,
          id: '',
          label: '',
          additionalFields: {}
        };
        setSelectOptions(options => [...options, loadMoreOption]);
      }

      // remove button in case if we load all pares
      if (fetchedExternadOptions && !fetchedExternadOptions.isLoading && !fetchedExternadOptions.isError && !fetchedExternadOptions.hasMore && selectOptions.find(option => option.isSpecial === true)) {
        setSelectOptions(options => options.filter(option => !option.isSpecial));
      }
    } else if (fetchedExternadOptions && !fetchedExternadOptions.isLoading && !fetchedExternadOptions.isError && fetchedExternadOptions.hasMore) {
      loadOptions('');
    }
  }, [fetchedExternadOptions, loadOptions, referenceType, selectOptions]);

  // set default value for non external options
  useEffect(() => {
    if (!property.externalOptions && property.options.length && property.fieldType !== propertyFieldTypes.checkbox) {
      const selectedValue = property.options.find(item => item.value === currentValue);
      setExternalValue(selectedValue ? selectedValue.value : property.options[0].value);
    }
  }, [property, currentValue, setExternalValue]);
  return {
    selectOptions,
    isDisabled
  };
};
export default useSelectOptions;